<template>
  <div>
    <section id="wat-wij-doen" class="content-wrapper page">
      <section class="row header">
        <ul class="breadcrumb">
          <li><router-link class="link" to="/">Home</router-link></li>
          <li>
            <router-link to="/wat-wij-doen"
              ><inline-svg
                src="/images/icons/chevron-right-solid.svg"
              ></inline-svg
              >Wat wij doen</router-link
            >
          </li>
          <li>
            <inline-svg src="/images/icons/chevron-right-solid.svg"></inline-svg
            >Print aanbesteden
          </li>
        </ul>
        <div class="col text">
          <h1>Onderscheidende dienstverlening</h1>
          <p>
            Als full service grafisch dienstverlener verzorgt Koninklijke Rijnja
            professionele printopdrachten voor diverse gemeenten,
            onderwijsorganisaties en andere (overheids)instellingen in
            Nederland. Deze organisaties kozen na een Europese of onderhandse
            aanbesteding voor onze onderscheidende aanpak en dienstverlening.
            Oriënteert uw organisatie zich op een aanbesteding voor uw
            printopdrachten? Wij nemen u graag mee in het proces van onze
            aanpak. Nodig ons uit voor een heldere kijk op wat wij u kunnen
            bieden.
          </p>
          <a class="link-button top-button" href="#contact"
            >Neem contact met ons op</a
          >
          <h2>Aanpak printopdrachten</h2>
          <p>
            Wij nemen u aan de hand van uw eisen- en wensenpakket nauwgezet mee
            in onze aanpak. Een toegewijd accountteam staat u in het volledige
            proces terzijde, vanaf de eerste kennismaking tot de implementatie
            en vervolgens tijdens de gehele duur van de raamovereenkomst.
          </p>
          <p>
            Wij voeren alle printopdrachten uit in eigen beheer, van
            voorbereiding tot de distributie, met eigen koeriers en eigen
            vervoer. Dat doen we vanuit vijf vestigingen verspreid over
            Nederland. Dat garandeert een snelle en soepele dienstverlening.
          </p>
          <h2>Betrouwbare kwaliteit</h2>
          <p>
            Als marktleider investeren wij voortdurend in vernieuwende
            technologie en duurzame printtechnieken voor veilige en innovatieve
            online-oplossingen. Wij werken volgens de hoogste en nieuwste
            kwaliteits- en milieumanagementnormen. Vanzelfsprekend zijn wij ISO
            9001:2015 en ISO 14001:2015 gecertificeerd.
          </p>
        </div>
        <div class="col header-circle-image">
          <div class="rijnja-foto"></div>
          <!-- <printen-en-meer></printen-en-meer> -->
        </div>
      </section>

      <section class="row full">
        <div class="col text">
          <h2>Secured printing</h2>
          <p>
            Wij waarborgen de beveiliging en vertrouwelijkheid van bestanden en
            gegevens gedurende het gehele proces. Hiervoor heeft Rijnja haar
            secured printing proces ontwikkeld. Dit proces is gecertificeerd
            volgens de nieuwste norm voor informatiebeveiliging: ISO 27001:2022.
            Met dit proces waarborgen wij gegevensbescherming bij AVG-gevoelige
            documenten voor overheden, tentamens en examens voor (hoge)scholen
            en universiteiten en zeer vertrouwelijke rapporten en dossiers voor
            bijvoorbeeld beursgenoteerde organisaties en diverse ambassades.
          </p>
          <router-link class="link-button" to="/secured-printing">
            Meer informatie over secured printing vindt u hier</router-link
          >
        </div>
      </section>

      <section class="row image-row">
        <img
          class=""
          src="@/images/pages/kwaliteit-duurzaamheid-betrouwbaarheid-diplomas.svg"
        />
      </section>
      <div class="anchor-tag" id="contact"></div>
      <section class="row" id="">
        <div class="col-single">
          <h1>Wilt u meer weten over onze diensten?</h1>
          <p>
            Benieuwd naar wat Koninklijke Rijnja voor u kan betekenen? Neem dan
            contact met ons op via onderstaand formulier.
          </p>

          <contact-form
            recipient="verkoop@rijnja.nl"
            class="form"
            subject="Informatieaanvraag diensten"
            conversion-id="McMQCKuxhJwYEKDetesD"
          ></contact-form>
          <p>
            Wilt u een van onze vestigingen direct bereiken? Bekijk de
            contactgegevens dan op onze
            <router-link class="link-text" to="/contact"
              >contactpagina</router-link
            >.
          </p>
        </div>
      </section>
    </section>
    <site-footer></site-footer>
  </div>
</template>

<script>
import ContactForm from '../../components/ContactForm.vue'
import SiteFooter from '../../components/SiteFooter.vue'
import PrintenEnMeer from './PrintenEnMeer.vue'
export default {
  components: { SiteFooter, PrintenEnMeer, ContactForm }
}
</script>

<style lang="scss" scoped>
.top-button {
  margin-bottom: 35px;
}
.archiveren {
  max-width: 360px;
}
.bestellen-bezorgen {
  max-width: 375px;
}

.kwaliteit {
  max-width: 370px;
}

.security {
  max-width: 400px;
}

.printstore {
  max-width: 365px;
}

.portals {
  max-width: 450px;
}

.form {
  margin: 20px 0;
}

.rijnja-foto {
  background-image: url('@/images/pages/rijnja-amsterdam-folder-l.jpg');
  width: 966px;
  height: 966px;
  border-radius: 50%;

  position: absolute;
  //top: -404px;
  top: -350px;
  left: 0;
  background-position-x: -245px;
  background-position-y: 229px;
}

.row.image-row {
  padding-top: 0;
  padding-bottom: 0;

  img {
    max-width: 955px;
    margin: 0 auto;
    width: 100%;
  }
}

.row.full {
  padding-top: 0;
}

.row.header {
  padding-bottom: 0;
}
</style>
